/**
 * This class represents counter that holds printed element positions in order.
 */
 export default class ElementsCounter {

    constructor(name)
    {
        this.elementsWrapper = $('[data-elements-counter="' + name + '"]');
        this.count = this.countElements();
    }

  /**
   * Will return count of elements under the counter.
   *
   * @returns {Number}
   */
    countElements()
    {
        return this.elementsWrapper.find('[data-element-position]').length;
    }

  /**
   * This function will recalculate elements positions and displays correct order.
   */
    recalculatePositions()
    {
        this.elementsWrapper.find('[data-element-position]').each((index, element) => {
            $(element).text((index + 1) + '');
        });
    }
 }
